// material-ui components
import React from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import styles from "assets/jss/material-dashboard-react/components/dropDownButtonStyle.js";

const useStyles = makeStyles(styles);

const useStyles2 = makeStyles((theme) =>
  createStyles({
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  })
);

export default function DropDownMenuPriority({ priority, setPriority }) {
  const classes = useStyles();
  const classes2 = useStyles2();

  const handleChange = (event) => {
    setPriority(event.target.value);
  };

  return (
    <FormControl
      variant="outlined"
      style={{ marginBottom: "15px" }}
      className={classes.formControl}
    >
      <InputLabel id="demo-simple-select-filled-label">Prioridade</InputLabel>
      <Select
        labelId="demo-simple-select-filled-label"
        id="demo-simple-select-filled"
        value={priority}
        onChange={handleChange}
        className={classes2.selectEmpty}
      >
        <MenuItem value={"A (Alto impacto, fácil de implementar)"}>
          A (Alto impacto, fácil de implementar)
        </MenuItem>
        <MenuItem value={"B (Baixo impacto, fácil de implementar)"}>
          B (Baixo impacto, fácil de implementar)
        </MenuItem>
        <MenuItem value={"C (Alto impacto, difícil de implementar)"}>
          C (Alto impacto, difícil de implementar)
        </MenuItem>
        <MenuItem value={"D (Baixo impacto, difícil de implementar)"}>
          D (Baixo impacto, difícil de implementar)
        </MenuItem>
      </Select>
    </FormControl>
  );
}
